import {
  SET_LANGUAGE,
  SET_LANGUAGE_SUCCESS,
  SET_LANGUAGE_FAILURE,
  SET_LANGUAGE_FROM_SERVER,

  GET_SADUKA_LANGUAGES,
  GET_SADUKA_LANGUAGES_SUCCESS,
  GET_SADUKA_LANGUAGES_FAIL,
} from 'cityads-v3/actions/language';

import { mapObjectize } from 'cityads-v3/utils/apiUtils';
import { keyBy } from 'lodash'

import { prepareLanguage, AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from 'cityads-v3/i18n/utils';

const languagesById = {
  'ru': {
    id  : 'ru',
    flag: 'russia',
    name: 'Русский'
  },
  'en': {
    id  : 'en',
    flag: 'united_states',
    name: 'English (United States)'
  },
  'zh': {
    id  : 'zh',
    flag: 'china',
    name: '中国（简体）'
  },
  'pt': {
    id  : 'pt',
    flag: 'brazil',
    name: 'Português (Brasil)'
  },
  'es': {
    id  : 'es',
    flag: 'spain',
    name: 'Español'
  },
  'my': {
    id  : 'my',
    flag: 'malaysia',
    name: 'Bahasa Malaysia'
  },
  'pl': {
    id  : 'pl',
    flag: 'poland',
    name: 'Polski'
  },
  'vi': {
    id  : 'vi',
    flag: 'vietnam',
    name: 'Tiếng Việt'
  },
};

const initialState = {
  language: prepareLanguage(getLocalLanguage() || DEFAULT_LANGUAGE),
  changingLanguageTo: null,
  languageList: AVAILABLE_LANGUAGES,
  languagesById,
  sadukaLanguages: [],
  sadukaLanguagesById: {},
  sadukaLanguagesByCode: {},
};

export default function language(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        changingLanguageTo: prepareLanguage(action.additional.language),
      };

    case SET_LANGUAGE_SUCCESS:
      return {
        ...state,
        language: prepareLanguage(action.additional.language),
        changingLanguageTo: null,
      };

    case SET_LANGUAGE_FAILURE:
      return {
        ...state,
        changingLanguageTo: null,
      };

    case SET_LANGUAGE_FROM_SERVER:
      return {
        ...state,
        language: prepareLanguage(action.additional.language),
      }

    case GET_SADUKA_LANGUAGES:
      return {
        ...state,
        isLoadedSadukaLanguages: false
      };
    case GET_SADUKA_LANGUAGES_SUCCESS:
      const sadukaLanguages = action.response.language.map(item => {
        return {
          ...item,
          id: +item.id,
          title: item.name,
          value: +item.id,
          default: !!+item.is_default
        }
      });
      const sadukaLanguagesById = mapObjectize(sadukaLanguages, 'value');
      return {
        ...state,
        isLoadedSadukaLanguages: true,
        sadukaLanguages,
        sadukaLanguagesById,
        sadukaLanguagesByCode: keyBy(sadukaLanguages, 'code'),
      };
    case GET_SADUKA_LANGUAGES_FAIL:
      return {
        ...state,
        isLoadedSadukaLanguages: false
      };

    default:
      return state;
  }
}

export function getLocalLanguage() {
  if (typeof localStorage === 'undefined') {
    return;
  }

  const localLanguage = prepareLanguage(localStorage.getItem('ca_lang'));

  if (localLanguage && languagesById[localLanguage]) {
    return localLanguage;
  }

  if (typeof navigator !== 'undefined') {
    if (typeof navigator.languages !== 'undefined') {
      return prepareLanguage(navigator.languages[0]);
    }

    if (typeof navigator.language !== 'undefined') {
      return prepareLanguage(navigator.language);
    }

    if (typeof navigator.userLanguage !== 'undefined') {
      return prepareLanguage(navigator.userLanguage);
    }
  }
}
